// Flag persistente "este canal necesita transcode HEVC→H.264 en este browser".
// Compartido entre Live (GridCell) y Playback (PlaybackPage) bajo la misma key
// vms.transcode.<deviceId>:<channel>, asi un canal marcado en Live se beneficia
// del shortcut en Playback y viceversa.
//
// El TTL evita que un canal con VPN temporalmente caida quede atrapado en el
// path transcode forever (peor caso CPU desperdiciada por hasta 7 dias).

const TTL_MS = 7 * 24 * 60 * 60_000;

export function transcodeKey(deviceId: number | null | undefined, channel: number | null | undefined): string | null {
  if (deviceId == null || channel == null) return null;
  return `vms.transcode.${deviceId}:${channel}`;
}

export function readTranscodeFlag(key: string | null): boolean {
  if (!key) return false;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return false;
    // Formato legacy "1" (pre-TTL): aceptar pero re-escribir con ts actual
    // para que entre al régimen TTL desde ya.
    if (raw === "1") {
      try { localStorage.setItem(key, JSON.stringify({ ts: Date.now() })); } catch {}
      return true;
    }
    const parsed = JSON.parse(raw) as { ts?: number };
    if (typeof parsed.ts !== "number") return false;
    if (Date.now() - parsed.ts > TTL_MS) {
      try { localStorage.removeItem(key); } catch {}
      return false;
    }
    return true;
  } catch { return false; }
}

export function writeTranscodeFlag(key: string | null): void {
  if (!key) return;
  try { localStorage.setItem(key, JSON.stringify({ ts: Date.now() })); } catch {}
}

export function clearTranscodeFlag(key: string | null): void {
  if (!key) return;
  try { localStorage.removeItem(key); } catch {}
}
